import { ref } from 'vue';

export const modalStore = {};

export function initModalState(name) {
  if (!modalStore[name]) {
    modalStore[name] = { isOpen: ref(false), params: ref(null) };
  }
  return modalStore[name];
}

export function getModalState(name) {
  return modalStore[name] || initModalState(name);
}

export function installModalCompat(app) {
  const hideTimers = {};
  const $modal = {
    show(name, params = {}) {
      const state = getModalState(name);
      // Cancel any pending param-clear from a previous hide()
      if (hideTimers[name]) {
        clearTimeout(hideTimers[name]);
        delete hideTimers[name];
      }
      state.params.value = params;
      state.isOpen.value = true;
    },
    hide(name) {
      const state = getModalState(name);
      state.isOpen.value = false;
      hideTimers[name] = setTimeout(() => {
        // Only clear params if the modal is still closed
        if (!state.isOpen.value) {
          state.params.value = null;
        }
        delete hideTimers[name];
      }, 300);
    },
    toggle(name, params = {}) {
      const state = getModalState(name);
      if (state.isOpen.value) {
        this.hide(name);
      } else {
        this.show(name, params);
      }
    },
  };
  app.config.globalProperties.$modal = $modal;
  app.provide('$modal', $modal);
}
